export default {
	name: 'bill-log-email-result',
	mixins: [],
	extends: {},
	components: {},
	props: ['phListChosen'],
	data() {
		return {

		};
	},
	computed: {

	},
	watch: {},
	created() {

	},
	mounted() {

	},
	updated() {},
	beforeDestroy() {},
	methods: {
		// 西元年月轉換為民國年月
		ADToRepublicEra(year, month) {
			if (year && month) {
				return year - 1911 + '年 ' + month + '月';
			}
		},
	},
};



// WEBPACK FOOTER //
// ./src/components/billLog/billLogEMailResult.js